// JsFromRoutes CacheKey 7d04b35e0cb7d797af51b0fd9bfe1eaf
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/omni_search_hits'),
}
